export default __webpack_public_path__ + "static/media/banner-contact.075cc46b.jpg";